/*
 * ORIMONO wishlist (replaces the Swym "Wishlist Plus" app).
 *
 * - Works without cookie consent: the list only exists because the visitor asked for it (like a cart),
 *   it is kept in this browser (localStorage) and is never sent to analytics or ad tools.
 * - No third-party requests. Only when Theme settings -> OM Wishlist has an endpoint AND a customer is
 *   logged in, the list is synced to ORIMONO's own wishlist service (customer metafield custom.wishlist).
 * - Hearts: any `.swym-add-to-wishlist-view-product` (theme cards, Boost filter cards, recently viewed)
 *   or `[data-om-wishlist]` element toggles the product. State: .om-wl-active + aria-pressed.
 * - Header count: elements with [data-om-wl-count].
 *
 * API: window.omWishlist.list() / has(id) / add(item) / remove(id) / toggle(item) / count() /
 *      on('change', fn) / off('change', fn) / refresh()
 *      item = { id: product id, v: variant id (optional), h: product handle, t: added timestamp (ms) }
 */
(function () {
  'use strict';
  if (window.omWishlist) return;

  var KEY = 'om_wishlist_v1';
  var META_KEY = 'om_wishlist_meta_v1';
  var MAX = 200;
  var TOMBSTONE_MS = 30 * 24 * 3600 * 1000;
  var SEL = '.swym-add-to-wishlist-view-product, [data-om-wishlist]';
  var CARD_SEL = '.boost-sd__product-item, .new-product-i-item, .product-card-wrapper, .card-wrapper, .grid__item, .swiper-slide';

  /* ---------- config (rendered by layout/theme.liquid) ---------- */
  var cfg = {};
  try {
    var cfgEl = document.getElementById('om-wishlist-config');
    if (cfgEl) cfg = JSON.parse(cfgEl.textContent || '{}') || {};
  } catch (e) {
    cfg = {};
  }
  var labels = {
    add: cfg.label_add || 'Add to Wishlist',
    remove: cfg.label_remove || 'Remove from Wishlist',
    added: cfg.msg_added || 'Added to wishlist',
    removed: cfg.msg_removed || 'Removed from wishlist'
  };

  /* ---------- storage (never throws) ---------- */
  function readRaw(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }
  function writeRaw(key, value) {
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch (e) {
      return false;
    }
  }

  var DIGITS = /^\d{1,20}$/;
  function clean(item) {
    if (!item || typeof item !== 'object') return null;
    var id = String(item.id == null ? '' : item.id).replace(/^gid:\/\/shopify\/Product\//, '');
    if (!DIGITS.test(id)) return null;
    var out = { id: id };
    var v = item.v == null ? '' : String(item.v).replace(/^gid:\/\/shopify\/ProductVariant\//, '');
    if (DIGITS.test(v)) out.v = v;
    var h = item.h == null ? '' : String(item.h);
    if (h && h.length <= 255 && !/[\s\/?#"'<>\\]/.test(h)) out.h = h;
    var t = Number(item.t);
    out.t = isFinite(t) && t > 0 ? Math.round(t) : Date.now();
    return out;
  }
  function cleanList(list) {
    var seen = {};
    var out = [];
    (Array.isArray(list) ? list : []).forEach(function (raw) {
      var it = clean(raw);
      if (!it) return;
      if (seen[it.id]) {
        var prev = seen[it.id];
        if (it.t > prev.t) {
          prev.t = it.t;
          if (it.v) prev.v = it.v;
          if (it.h) prev.h = it.h;
        }
        return;
      }
      seen[it.id] = it;
      out.push(it);
    });
    out.sort(function (a, b) {
      return b.t - a.t;
    });
    return out.slice(0, MAX);
  }
  function parse(raw) {
    if (!raw) return [];
    try {
      return cleanList(JSON.parse(raw));
    } catch (e) {
      return [];
    }
  }
  function readMeta() {
    try {
      var m = JSON.parse(readRaw(META_KEY) || '{}');
      if (!m || typeof m !== 'object') m = {};
      if (!m.removed || typeof m.removed !== 'object') m.removed = {};
      return m;
    } catch (e) {
      return { removed: {} };
    }
  }
  function writeMeta(m) {
    var now = Date.now();
    Object.keys(m.removed || {}).forEach(function (id) {
      if (now - m.removed[id] > TOMBSTONE_MS) delete m.removed[id];
    });
    writeRaw(META_KEY, JSON.stringify(m));
  }

  var items = parse(readRaw(KEY));
  var listeners = [];

  function snapshot() {
    return items.map(function (it) {
      var c = { id: it.id, t: it.t };
      if (it.v) c.v = it.v;
      if (it.h) c.h = it.h;
      return c;
    });
  }
  function emit(source) {
    var list = snapshot();
    listeners.slice().forEach(function (fn) {
      try {
        fn(list, source);
      } catch (e) {
        /* a listener must not break the wishlist */
      }
    });
    try {
      document.dispatchEvent(new CustomEvent('om:wishlist:change', { detail: { items: list, source: source } }));
    } catch (e) {
      /* old browsers */
    }
    paintAll();
  }
  /* persist + notify. returns false when the browser refused to store (private mode / quota) */
  function commit(next, source) {
    items = cleanList(next);
    var ok = writeRaw(KEY, JSON.stringify(items));
    emit(source || 'local');
    return ok;
  }
  function find(id) {
    id = String(id);
    for (var i = 0; i < items.length; i++) if (items[i].id === id) return items[i];
    return null;
  }

  /* ---------- account sync (only when configured + logged in) ---------- */
  var sync = {
    on: !!(cfg.endpoint && cfg.cid && cfg.sig && window.fetch),
    timer: null,
    busy: false,
    again: false
  };
  function endpointUrl(qs) {
    var base = String(cfg.endpoint).replace(/\/+$/, '');
    if (!/\/wishlist$/.test(base)) base += '/wishlist';
    return base + (qs || '');
  }
  function authQuery() {
    return '?cid=' + encodeURIComponent(cfg.cid) + '&ts=' + encodeURIComponent(cfg.ts) + '&sig=' + encodeURIComponent(cfg.sig);
  }
  function markDirty(id, removed) {
    if (!sync.on) return;
    var m = readMeta();
    m.dirty = true;
    if (removed) m.removed[id] = Date.now();
    else delete m.removed[id];
    writeMeta(m);
  }
  function push(keepalive) {
    if (!sync.on) return;
    clearTimeout(sync.timer);
    sync.timer = null;
    if (sync.busy) {
      sync.again = true;
      return;
    }
    sync.busy = true;
    var sent = JSON.stringify(items);
    /* text/plain = "simple" CORS request: no preflight, works with keepalive while the page unloads */
    fetch(endpointUrl(), {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      keepalive: !!keepalive,
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify({ cid: String(cfg.cid), ts: String(cfg.ts), sig: String(cfg.sig), items: snapshot() })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        if (JSON.stringify(items) === sent) {
          var m = readMeta();
          m.dirty = false;
          m.cid = String(cfg.cid);
          writeMeta(m);
        }
      })
      .catch(function () {
        /* stays dirty: next page view merges and retries */
      })
      .then(function () {
        sync.busy = false;
        if (sync.again) {
          sync.again = false;
          schedulePush();
        }
      });
  }
  function schedulePush() {
    if (!sync.on) return;
    clearTimeout(sync.timer);
    sync.timer = setTimeout(push, 800);
  }
  function merge(server) {
    var m = readMeta();
    var cid = String(cfg.cid);
    server = cleanList(server);
    var next;
    if (!m.cid) {
      /* first sync on this device: bring the guest list into the account */
      next = server.concat(items);
    } else if (m.cid !== cid) {
      /* another customer used this browser before: do not mix their list into this account */
      next = server;
      m.removed = {};
    } else if (m.dirty) {
      /* changes made here that did not reach the server yet */
      next = server.concat(items).filter(function (it) {
        var gone = m.removed[it.id];
        return !(gone && gone >= it.t);
      });
    } else {
      next = server; /* server is the truth (removals on other devices apply here too) */
    }
    next = cleanList(next);
    var changedLocal = JSON.stringify(next) !== JSON.stringify(items);
    var changedServer = JSON.stringify(next) !== JSON.stringify(server);
    m.cid = cid;
    m.dirty = changedServer;
    writeMeta(m);
    if (changedLocal) commit(next, 'sync');
    if (changedServer) schedulePush();
  }
  function startSync() {
    if (!sync.on) return;
    if (Array.isArray(cfg.server)) {
      /* list rendered by Liquid from the customer metafield: no request needed */
      merge(cfg.server);
      return;
    }
    fetch(endpointUrl(authQuery()), { method: 'GET', mode: 'cors', credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        merge(data && Array.isArray(data.items) ? data.items : []);
      })
      .catch(function () {
        /* server unavailable: keep working locally */
      });
  }

  /* ---------- public API ---------- */
  function add(item) {
    var it = clean(item);
    if (!it) return false;
    it.t = Date.now();
    var prev = find(it.id);
    var next = items.filter(function (x) {
      return x.id !== it.id;
    });
    if (prev) {
      if (!it.v && prev.v) it.v = prev.v;
      if (!it.h && prev.h) it.h = prev.h;
    }
    next.unshift(it);
    markDirty(it.id, false);
    var ok = commit(next, 'local');
    schedulePush();
    return ok;
  }
  function remove(id) {
    id = String(id == null ? '' : id).replace(/^gid:\/\/shopify\/Product\//, '');
    if (!find(id)) return true;
    markDirty(id, true);
    var ok = commit(
      items.filter(function (x) {
        return x.id !== id;
      }),
      'local'
    );
    schedulePush();
    return ok;
  }
  function has(id) {
    return !!find(id);
  }
  function toggle(item) {
    if (!item) return false;
    if (has(item.id)) {
      remove(item.id);
      return false;
    }
    add(item);
    return true;
  }

  /* ---------- hearts ---------- */
  function handleFromUrl(url) {
    if (!url) return '';
    try {
      var path = new URL(url, window.location.origin).pathname;
      var m = path.match(/\/products\/([^\/?#]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) {
      return '';
    }
  }
  function productIdOf(btn) {
    var id = btn.getAttribute('data-product-id');
    if (!id) {
      var m = String(btn.className).match(/(?:^|\s)product_(\d+)/);
      id = m ? m[1] : '';
    }
    return String(id || '').replace(/^gid:\/\/shopify\/Product\//, '');
  }
  function itemFromButton(btn) {
    var h = btn.getAttribute('data-product-handle') || handleFromUrl(btn.getAttribute('data-product-url'));
    if (!h) {
      var link = btn.closest('a[href*="/products/"]');
      if (!link) {
        var card = btn.closest(CARD_SEL);
        link = card && card.querySelector('a[href*="/products/"]');
      }
      if (link) h = handleFromUrl(link.getAttribute('href'));
    }
    return { id: productIdOf(btn), v: btn.getAttribute('data-variant-id'), h: h };
  }
  function paint(btn) {
    var id = productIdOf(btn);
    if (!id) return;
    var on = has(id);
    btn.classList.add('om-wl-ready');
    btn.classList.toggle('om-wl-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    if (btn.tagName === 'BUTTON' && !btn.getAttribute('type')) btn.setAttribute('type', 'button');
    var text = btn.querySelector('.om-wl-label');
    if (text) {
      var t = on ? btn.getAttribute('data-label-added') : btn.getAttribute('data-label-add');
      if (t) text.textContent = t;
      btn.removeAttribute('aria-label');
    } else {
      btn.setAttribute('aria-label', on ? labels.remove : labels.add);
    }
  }
  function paintCounts() {
    var n = items.length;
    document.querySelectorAll('[data-om-wl-count]').forEach(function (el) {
      el.textContent = n > 0 ? String(n) : '';
      el.toggleAttribute('hidden', n === 0);
      el.classList.toggle('om-wl-count--wide', n > 9);
    });
  }
  function paintAll() {
    document.querySelectorAll(SEL).forEach(paint);
    paintCounts();
  }
  var live;
  function announce(msg) {
    if (!live) {
      live = document.createElement('div');
      live.className = 'visually-hidden om-wl-live';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () {
      live.textContent = msg;
    }, 30);
  }

  /* capture on window: runs before the card link, Boost's React handlers and theme click handlers */
  function onClick(e) {
    var btn = e.target && e.target.closest && e.target.closest(SEL);
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    var item = itemFromButton(btn);
    if (!item.id) return;
    var on = toggle(item);
    announce(on ? labels.added : labels.removed);
  }
  window.addEventListener('click', onClick, true);

  /* hearts rendered later (Boost grid, sliders, recently viewed): paint only new ones */
  var queued = false;
  function paintNew() {
    queued = false;
    document.querySelectorAll('.swym-add-to-wishlist-view-product:not(.om-wl-ready), [data-om-wishlist]:not(.om-wl-ready)').forEach(paint);
    paintCounts();
  }
  function queue() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(paintNew);
  }

  /* other tabs changed the list */
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    items = parse(e.newValue);
    emit('tab');
  });
  /* flush a pending sync when leaving the page */
  window.addEventListener('pagehide', function () {
    if (sync.timer) push(true);
  });

  window.omWishlist = {
    list: snapshot,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    count: function () {
      return items.length;
    },
    on: function (name, fn) {
      if (name === 'change' && typeof fn === 'function') listeners.push(fn);
    },
    off: function (name, fn) {
      listeners = listeners.filter(function (f) {
        return f !== fn;
      });
    },
    refresh: paintAll,
    syncEnabled: sync.on
  };

  function start() {
    paintAll();
    try {
      new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
    } catch (e) {
      /* ignore */
    }
    startSync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
